import React from 'react'
import { Well, Table, Button } from 'react-bootstrap'
import Icon from '_/shared/components/icon'
import icons from '_/config/icons.json'
import ReactMixin from 'react-mixin'
import ImmutableRenderMixin from 'react-immutable-render-mixin'
import EditExhibitModal from '_/shared/components/editExhibitModal'
import getTransactionType from '_/utils/getTransactionType'
import { Map } from 'immutable'

@ReactMixin.decorate(ImmutableRenderMixin)
class ExhibitTable extends React.Component {
  static propTypes = {
    account: React.PropTypes.object.isRequired,
    editable: React.PropTypes.bool,
    exhibits: React.PropTypes.object.isRequired,
    exhibitMetadata: React.PropTypes.object.isRequired,
    transaction: React.PropTypes.object.isRequired,
    onChange: React.PropTypes.func.isRequired
  }

  static contextTypes = {
    store: React.PropTypes.object,
    notify: React.PropTypes.func
  }

  constructor(props, context) {
    super(props, context)
    this.state = {
      activeIdx: null,
      isModalOpen: false,
      activeExhibit: Map()
    }
  }

  componentWillReceiveProps (props) {
    this.state = {
      activeIdx: null,
      isModalOpen: false,
      activeExhibit: Map()
    }
  }

  handleExhibitOpen (exhibit, idx, evt) {
    evt.preventDefault()
    this.setState({
      activeIdx: idx,
      activeExhibit: exhibit,
      isModalOpen: true
    })
  }

  handleExhibitAdd (exhibit) {
    const { exhibits, onChange } = this.props
    onChange(exhibits.push(exhibit))
  }

  handleExhibitChange (exhibit) {
    const { exhibits, onChange } = this.props
    const { activeIdx } = this.state
    onChange(exhibits.set(activeIdx, exhibit))
  }

  handleExhibitDelete (exhibit) {
    const { exhibits, onChange } = this.props
    const { activeIdx } = this.state
    onChange(exhibits.delete(activeIdx))
  }

  async share (exhibit, idx, evt) {
    evt.preventDefault()
    const { transaction, exhibits, onChange } = this.props
    const { store, notify } = this.context
    const type = getTransactionType(transaction) + 's'
    const id = transaction.get('id')
    const exhibitId = exhibit.get('id')

    try {
      const sharedExhibit = await store.post(`/${type}/${id}/exhibits/${exhibitId}/share`)
      notify('Exhibit shared')
      onChange(exhibits.set(idx, sharedExhibit))
    } catch (er) {
      console.error(er)
      notify(er.response.body.error)
    }
  }

  handleModalClose () {
    this.setState({
      activeIdx: null,
      isModalOpen: false,
      activeExhibit: Map()
    })
  }

  isValueHidden (exhibit) {
    const { transaction, account, exhibitMetadata } = this.props
    const isPrivate = transaction.get('isPrivate')
    const isLocked = transaction.has('pointsWorth')
    const groupType = account.getIn(['group', 'type'])
    const groupId = exhibit.get('groupId')
    const userId = exhibit.get('userId')
    const metadata = exhibitMetadata.get(exhibit.get('type'))

    const dataAvailable =
      !isPrivate && // A public record
      groupType === 'Point' && // Only applies to point group
      isLocked && // Record hasn't been unlocked
      !metadata.get('unlocked') && // Field isn't pre-unlocked
      userId && // Data exists in the field
      account.getIn(['group', 'id']) !== groupId && // Wasn't shared by group
      account.get('id') !== userId // User did not share from another group

    return dataAvailable
  }

  renderEdit (exhibit, idx) {
    const { editable } = this.props
    if (!editable) return null

    return (
      <td>
        <a href="" onClick={this.handleExhibitOpen.bind(this, exhibit, idx)}>
          <Icon name={icons.edit} fixedWidth />
        </a>
      </td>
    )
  }

  renderShare (exhibit, idx) {
    const { account, transaction, exhibitMetadata } = this.props
    const isPrivate = transaction.get('isPrivate')
    const metadata = exhibitMetadata.get(exhibit.get('type'))
    const points = metadata.get('points') * 5
    const isShared = exhibit.has('shareId')

    if (isShared) {
      return (
        <td><i>Shared</i></td>
      )
    }

    const canShare =
      isPrivate && // Can only share private exhibits
      transaction.has('public') && // Has a public record to share with
      account.getIn(['group', 'type']) === 'Point' && // Only from a point group
      !transaction.get('unsharable') && // Must not be marked as unshareable
      !exhibit.has('shareId') // Must not have already shared

    if (!canShare) return null

    return (
      <td>
        <a href="#" onClick={this.share.bind(this, exhibit, idx)}>
          Share publicly for <b>{points} points</b>
        </a>
      </td>
    )
  }

  renderExhibit (exhibit, idx) {
    const { account, exhibitMetadata } = this.props
    const isHidden = this.isValueHidden(exhibit)
    const metadata = exhibitMetadata.get(exhibit.get('type'))
    const groupType = account.getIn(['group', 'type'])

    // Only show limited exhibits for limited users
    if (groupType === 'Limited' && !metadata.get('limited')) return null

    return (
      <tr key={idx}>
        {this.renderEdit(exhibit, idx)}
        <td>
          {isHidden
            ? <i className="text-muted">Data available...</i>
            : <a href={exhibit.get('link')} target="_blank">{exhibit.get('filename')}</a>}
        </td>
        <td>{exhibit.get('type')}</td>
        <td>{isHidden ? <i className="text-muted">Data available...</i> : exhibit.get('description')}</td>
        {this.renderShare(exhibit, idx)}
      </tr>
    )
  }

  render () {
    const { exhibits, exhibitMetadata, transaction, editable } = this.props
    const { activeExhibit, isModalOpen } = this.state
    const exhibitsExist = exhibits.size !== 0

    if (!exhibitsExist && !editable) return null

    return (
      <Well style={{padding: 8}}>
        <h4><b>Exhibits</b>&nbsp;
          {editable &&
            <Button
              bsSize="xsmall"
              bsStyle="success"
              onClick={this.handleExhibitOpen.bind(this, Map(), null)}>
              Add new
            </Button>
          }
        </h4>
        {exhibitsExist &&
          <Table className="redi-component-table">
            <thead>
              <tr>
                {editable && <th width={30} />}
                <th width={140}>File Name</th>
                <th width={140}>Type</th>
                <th>Description</th>
                <th width={200}>Status</th>
              </tr>
            </thead>
            <tbody>
              {exhibits.map(::this.renderExhibit)}
            </tbody>
          </Table>
        }

        {!exhibitsExist &&
          <p>
            There are no exhibits attached to this transaction. <a href="" onClick={this.handleExhibitOpen.bind(this, Map(), null)}>Create an exhibit</a>
          </p>
        }

        <EditExhibitModal
          show={isModalOpen}
          transaction={transaction}
          exhibit={activeExhibit}
          exhibitTypes={exhibitMetadata.get('_types').toJS()}
          onAdd={::this.handleExhibitAdd}
          onChange={::this.handleExhibitChange}
          onRemove={::this.handleExhibitDelete}
          onHide={::this.handleModalClose} />
      </Well>
    )
  }
}

export default ExhibitTable



// WEBPACK FOOTER //
// ./modules/shared/components/exhibitTable.js